module.exports = __webpack_public_path__ + "img/202306_Cell.ac5ae296.png";